"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRoleTypes = exports.userRoleReducer = exports.userRoleAction = void 0;
const user_role_component_1 = __importDefault(require("./sub-components/user-role.component"));
const user_role_action_1 = __importDefault(require("./user-role.action"));
exports.userRoleAction = user_role_action_1.default;
const user_role_reducer_1 = __importDefault(require("./user-role.reducer"));
exports.userRoleReducer = user_role_reducer_1.default;
const user_role_types_1 = require("./user-role.types");
Object.defineProperty(exports, "userRoleTypes", { enumerable: true, get: function () { return user_role_types_1.userRoleTypes; } });
exports.default = user_role_component_1.default;
